var map = {
	"./tombola-online-de.md": 9121,
	"./tombola-online-en.md": 9989,
	"./tombola-online-es.md": 4965,
	"./tombola-online-fr.md": 1012,
	"./tombola-online-it.md": 4015,
	"./tombola-online-pt.md": 6760,
	"./tombola-online-ro.md": 2657,
	"./tombola-online-ru.md": 3348,
	"./tombola-online-tr.md": 4536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9069;